import React from 'react';
import { useFormContext } from 'react-hook-form';
import classNames from 'classnames';
import styles from '../DataExtractionTemplate.module.scss';
import { WizardStateInterface } from '../hooks/useWizardState';
import { interventionsPendoKeys } from './InterventionsPanel/InterventionsWizardConfig';
import {
  Button,
  AccordionGroup,
  AccordionHeader,
  AccordionContent,
  AccordionControls,
  Heading,
  Text,
} from 'components/core';

type Props = {
  title: string;
  isInitiallyOpen: boolean;
  subTitle: string;
  wizard?: WizardStateInterface;
  children: React.ReactElement;
  pendoKey?: string;
  ariaLabel?: string;
};

export const TemplateSection = ({
  title,
  isInitiallyOpen,
  subTitle,
  wizard,
  children,
  pendoKey,
  ariaLabel,
}: Props) => {
  const shouldRenderAsAccordion = !wizard?.shouldForceWizardUse;
  const {
    formState: { isValid },
  } = useFormContext();

  return shouldRenderAsAccordion ? (
    <AccordionGroup
      className={styles.TemplateAccordionGroup}
      initiallyOpen={isInitiallyOpen}
    >
      <AccordionHeader
        className={styles.TemplateAccordionHeader}
        chevronPosition="right"
        disabled={!isValid}
      >
        <span
          className={classNames({
            [styles.TemplateAccordionHeaderTitle]: true,
            [styles.HasHeaderButtons]: wizard?.showHeaderButtons,
          })}
          id={title.toLowerCase().replace(/ /g, '_')}
        >
          {title}
        </span>
        <span
          className={classNames({
            [styles.SubTitle]: true,
            [styles.HasHeaderButtons]: wizard?.showHeaderButtons,
          })}
        >
          {subTitle}
        </span>
        <AccordionControls>
          {(wizard?.showHeaderButtons && (
            <Button
              size="sm"
              type="primary"
              variant="outline"
              onClick={() => {
                wizard?.setWizardOpen(true);
              }}
              aria-label="Edit set up"
              data-pendo-key={interventionsPendoKeys.editSetup}
            >
              <Text size="sm">Edit set up</Text>
            </Button>
          )) || <></>}
          <Button
            variant="outline"
            onClick={() => undefined}
            className={styles.PreviewButton}
            data-pendo-key={pendoKey}
            aria-label={ariaLabel}
          >
            Preview
          </Button>
        </AccordionControls>
      </AccordionHeader>
      <AccordionContent>{children}</AccordionContent>
    </AccordionGroup>
  ) : (
    <section className={styles.SectionHeader}>
      <div className={styles.HeaderContent}>
        <Heading
          type="h4"
          component="h3"
          variant="brand"
          className={styles.TemplateAccordionHeaderTitle}
          id={title.toLowerCase().replace(/ /g, '_')}
        >
          <div>{title}</div>
        </Heading>
        <div className={styles.SubTitle}>{subTitle}</div>
      </div>
      <div className={styles.HeaderControls}>
        <Button type="primary" onClick={() => wizard.setWizardOpen(true)}>
          Set Up
        </Button>
      </div>
    </section>
  );
};
